import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { switchMap, map } from 'rxjs/operators';
import { CommissionPeriodResponse, CommissionPeriodId } from '@business/entities/commission';
import { CommissionPeriodAPI } from '@business/api/commission_period';
import { R } from '@core/utils/r';

export class CommissionPeriodBloc extends BaseBloc {
  private readonly periodsRepo = new Repository<CommissionPeriodResponse>({
    getItemId: period => period.id,
  });

  readonly periods$ = this.periodsRepo.items$.pipe(
    map(periods =>
      R.sortBy(periods, [
        'current',
        item => {
          return item.id === 'custom' ? 1 : 0;
        },
        'startDate',
      ]).reverse(),
    ),
  );
  readonly period$ = this.periodsRepo.selectItem;

  onReset() {
    this.periodsRepo.reset();
  }

  fetchPeriods = () => {
    return CommissionPeriodAPI.fetchPeriods().pipe(
      this.periodsRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_commission_period_error') }),
    );
  };

  fetchPeriod = (id: CommissionPeriodId, dateRange: string) => {
    return CommissionPeriodAPI.fetchPeriod(id, dateRange).pipe(
      this.periodsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_commission_period_error') }),
    );
  };
}
